import clsx from "clsx"
import { memo } from "react"

import useIsDesktop from "@hooks/useIsDesktop"

import { faIcon } from "@utils/faIcon"

import { Icon, NavigationLink } from "@atoms"

import styles from "./SideBarItem.module.scss"
import { SideBarItemProps } from "./SideBarItem.types"

function SideBarItem(props: SideBarItemProps) {
    const {
        variant = "default",
        className,

        label,
        icon,
        iconActive,
        showNotification = false,

        path,
        onClick,
        onActive,

        isExpanded = false,
        isDisabled = false,
        isActive = undefined,
        _isFocused = false,
        _isHovered = false,
        isPressed = false,
    } = props

    const isDesktop = useIsDesktop()

    const isKeyboardNavigationEnabled = !isDisabled && (variant !== "groupItem" || isExpanded)

    const handleClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        isDisabled ? event.preventDefault() : onClick?.(event)
    }

    const renderIcon = (isActive: boolean) => {
        if (!icon || variant === "groupItem") {
            return null
        } else {
            return (
                <Icon
                    icon={icon}
                    iconOnActive={iconActive}
                    isActive={isActive || isExpanded}
                    className={styles.icon}
                    size={14}
                />
            )
        }
    }

    return (
        <NavigationLink
            title={label}
            path={path}
            className={clsx(styles.base, className, styles[variant], {
                [styles.disabled]: isDisabled,
                [styles.focused]: _isFocused,
                [styles.hovered]: _isHovered,
                [styles.pressed]: isPressed,
                [styles.active]: isActive,
                [styles.expanded]: isExpanded,
            })}
            activeClassName={styles.active}
            onClick={handleClick}
            isTabbable={isKeyboardNavigationEnabled}
            isActive={isActive}
            onActive={onActive}
        >
            {(isActive) => (
                <>
                    {renderIcon(isActive)}
                    <span className={styles.text}>{label}</span>

                    {variant === "groupHead" && (
                        <div className={styles.chevronWrap}>
                            <Icon
                                size={isDesktop ? 10 : 14}
                                icon={faIcon({ name: "caret-left", style: "solid" })}
                                className={clsx(styles.chevron, { [styles.expanded]: isExpanded })}
                                container="fixedHeight"
                            />
                        </div>
                    )}

                    {showNotification && (
                        <Icon
                            icon={faIcon({ name: "circle-small", style: "solid" })}
                            size={8}
                            className={styles.notification}
                        />
                    )}
                </>
            )}
        </NavigationLink>
    )
}

export default memo(SideBarItem)
